import { ReactNode } from "react";
import arrowIcon from "@ingka/ssr-icon/paths/arrow-right";
import {
  ArrowButton,
  ButtonWrapper,
  Children,
  Content,
  ImageWrapper,
  Label,
  Title,
  Wrapper,
  StyledLink,
  SlideShowWrapper,
} from "./style";
import Badges, { Colors } from "./Badges";
import AspectRatioImage from "../AspectRatioImage";
import ConditionalRender from "../ConditionalRender";

type PropsType = {
  title: string;
  label: string;
  aspectRatioImageProps: {
    src: string;
    srcSet: string;
    ratio: "square" | "standard" | "wide" | "portrait";
    loading?: string;
  };
  children: ReactNode;
  buttonText: string;
  badges?: [string, Colors][];
  eventPath: string;
  inSlideShow: boolean;
  storeName?: string;
};

const Card = (props: PropsType) => {
  const WrapperElement = props.inSlideShow ? SlideShowWrapper : Wrapper;

  return (
    <StyledLink to={props.eventPath}>
      <WrapperElement>
        <Content>
          <Title>{props.title}</Title>
          <ConditionalRender predicate={Boolean(props.storeName)}>
            <p>{props.storeName}</p>
          </ConditionalRender>
          <Label>{props.label}</Label>
          <Children>{props.children}</Children>

          <ButtonWrapper>
            <ArrowButton
              type="secondary"
              ssrIcon={arrowIcon}
              iconOnly={true}
              text={props.buttonText}
            />
          </ButtonWrapper>
        </Content>
        <ImageWrapper>
          <Badges badges={props.badges || []} />
          <AspectRatioImage
            src={props.aspectRatioImageProps.src}
            srcSet={props.aspectRatioImageProps.srcSet}
            ratio={props.aspectRatioImageProps.ratio}
            loading={props.aspectRatioImageProps.loading}
            alt=""
          />
        </ImageWrapper>
      </WrapperElement>
    </StyledLink>
  );
};

export default Card;
